module.exports = __webpack_public_path__ + "img/01.a48766d3.jpg";